import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import "../../css/sidebar.css";

const Sidebar = ({ onCollapseChange }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout, loading } = useContext(AuthContext);

  const [collapsed, setCollapsed] = useState(false);
  const [openSection, setOpenSection] = useState(localStorage.getItem("openSection") || null);
  const [hoverSubmenu, setHoverSubmenu] = useState(null);
  const [submenuPosition, setSubmenuPosition] = useState(0);

  const isActive = (path) => location.pathname.startsWith(path);


  const toggleSection = (section) => {
    const newSection = openSection === section ? null : section;
    setOpenSection(newSection);
    localStorage.setItem("openSection", newSection || "");
  };

 const canViewAllGH = () => {
  if (!user) return false;

  const role = user.role;
  const area = Number(user.area);

  return (
    role === "SuperAdmin" ||
    role === "Director General" ||
    role === "Auditor" ||
    role === "Sst" ||
    role === "Apoyo Sst" ||
    (role === "Coordinador" && area === 5) ||
    (role === "Apoyo" && area === 5)
  );
};

  const isCoordinadorOtraArea = () => {
    if (!user) return false;
    return user.role === "Coordinador" && Number(user.area) !== 5;
  };

const canAccess = (module) => {
  if (!user) return false;

  const role = user.role;
  const area = Number(user.area);

  // Roles que pueden ver todo
  if (["SuperAdmin", "Auditor", "Director General"].includes(role)) {
    return true;
  }

  // PERMISOS POR ÁREA
  const areaPermissions = {
    1: { // LA BELLOTA
      Coordinador: [
        "ofertas",
       "postulaciones",
        "entrevistas",
        "hojasdevida",
        "programas",
        "plan",
        "program_files"
      ],
      Apoyo: [
        "ofertas",
        "postulaciones",
        "entidades",
        "propuestas"
      ]
    },
    2: { // PROYECTOS
      Coordinador: [
        "ofertas",
        "postulaciones",
        "entrevistas",
        "hojasdevida",
        "entidades",
        "propuestas",
        "contrato",
        "asignacion_contrato",
        "programas",
        "plan",
        "program_files"
      ],
      Apoyo: [
        "ofertas",
        "postulaciones",
        "entidades",
        "propuestas"
      ]
    },
    3: { // PRIMERA INFANCIA
      Coordinador: [
        "ofertas",
        "postulaciones",
        "entrevistas",
        "hojasdevida",
        "programas",
        "plan",
        "program_files"
      ],
      Apoyo: [
        "ofertas",
        "postulaciones",
        "entidades",
        "propuestas"
      ]
    },
    4: { // PROTECCIÓN Y EDUCACIÓN
      Coordinador: [
        "ofertas",
        "postulaciones",
        "entrevistas",
        "hojasdevida",
        "programas",
        "plan",
        "program_files"
      ],
      Apoyo: [
        "ofertas",
        "postulaciones",
        "entidades",
        "propuestas"
      ]
    },
    5: { // Gestión Humana
      Coordinador: [
        "ofertas",
        "postulaciones",
        "hojasdevida",
        "contratacion",
        "entrevistas",
        "examenocupacional",
        "reportes",
        "plan",
        "programas",
        "program_files"
      ],
      Apoyo: [
        "ofertas",
        "postulaciones",
        "hojasdevida",
        "entrevistas",
        "reportes",
        "contratacion"
      ]
    },
    6: { // ADMINISTRATIVA Y FINANCIERA
      Coordinador: [
        "ofertas",
        "postulaciones",
        "entrevistas",
        "hojasdevida",
        "programas",
        "plan",
        "program_files",
        "informacion_general"
      ],
      Apoyo: [
        "ofertas",
        "postulaciones",
        "entidades",
        "propuestas",
        "informacion_general"
      ]
    },
  };

  if (areaPermissions[area]?.[role]?.includes(module)) {
    return true;
  }

  // PERMISOS SOLO POR ROL
  const rolePermissions = {
    Empleado: ["ofertas", "postulaciones", "hojasdevida"],
    Externo: ["ofertas", "postulaciones", "hojasdevida"],
    Comunicaciones: ["ofertas", "postulaciones", "hojasdevida"],
    Sst: ["ofertas","postulaciones","examenocupacional"],
    "Apoyo Sst": ["ofertas","postulaciones","examenocupacional"]
  };

  return rolePermissions[role]?.includes(module);
};
  // Agrupaciones de módulos
  const gestionHumanaModules = ["ofertas","postulaciones","hojasdevida","contratacion","entrevistas","examenocupacional","reportes"];
  const proyectos = ["entidades","propuestas","contrato","asignacion_contrato"];
  const configuracionModules = ["usuarios", "centrocostos"];
  const plan_accion = ["plan", "programas", "program_files"];
  const area_administrativa = ["informacion_general", "programas", "program_files"];

  // Validar si se debe mostrar el menú completo
const canAccessGestionHumana =
  canViewAllGH() ||
  gestionHumanaModules.some((mod) => canAccess(mod));
  const canAccessProyectos = proyectos.some((mod) => canAccess(mod));
  const canAccessConfiguracion = configuracionModules.some((mod) => canAccess(mod));
  const canAccessPlanAccion = plan_accion.some((mod) => canAccess(mod));
  const canAccessAreaAdministrativa= area_administrativa.some((mod) => canAccess(mod));

  /* Cerrar submenu flotante al hacer clic fuera */
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        !document.querySelector(".floating-submenu")?.contains(e.target) &&
        !document.querySelector(".sidebar")?.contains(e.target)
      ) {
        setHoverSubmenu(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  /* Captura posición del botón clickeado */
  const handleCollapsedClick = (e, section) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setSubmenuPosition(rect.top);
    setHoverSubmenu(hoverSubmenu === section ? null : section);
  };

  const toggleCollapsed = () => {
    const newState = !collapsed;
    setCollapsed(newState);
    onCollapseChange?.(newState);
  };
const rolesConHojaPropia = ["Externo", "Comunicaciones", "Empleado"];

// AGREGAMOS coordinador de otra área
const isHojaPropia =
  rolesConHojaPropia.includes(user?.role) ||
  isCoordinadorOtraArea();

const hojaVidaPath = isHojaPropia
  ? "/session/curriculum/mycurriculum"
  : "/session/curriculum/curriculum";
  if (!user) {
    return null;
  }

  return (
    <>
      <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
        {/* Botón colapsar */}
        <button className="toggle-btn" onClick={toggleCollapsed}>
          <i className={`bi ${collapsed ? "bi-caret-right" : "bi-caret-left"}`} />
        </button>

        {/* Header del usuario */}
        <div
          className="sidebar-header"
          onClick={() => navigate("/session/profile")}
          style={{ cursor: "pointer" }}
        >
          <div className="user-info">
            <i className="bi bi-person-circle user-avatar"></i>
            {!collapsed && (
              <div>
                {loading ? (
                  <span className="user-name">Cargando...</span>
                ) : user ? (
                  <>
                    <span className="user-name">{user.first_name} {user.last_name}</span>
                    <span className="user-role">{user.role}</span>
                  </>
                ) : (
                  <span className="user-name">No logueado</span>
                )}
              </div>
            )}
          </div>
        </div>

        {/* MENÚ */}
        <div className="sidebar-menu">
          <div className="sidebar-section">
            <button
              className={`sidebar-section-btn ${isActive("/session/dashboard") ? "active" : ""}`}
              onClick={() => navigate("/session/dashboard")}
            >
              <i className="bi bi-speedometer2 me-2"></i>
              {!collapsed && <span>Dashboard</span>}
            </button>
          </div>

          {/* GESTIÓN HUMANA */}
          {canAccessGestionHumana && (
            <div className="sidebar-section">
              <button
                className="sidebar-section-btn"
                onClick={(e) =>
                  collapsed ? handleCollapsedClick(e, "humana") : toggleSection("humana")
                }
              >
                <i className="bi bi-people-fill me-2"></i>
                {!collapsed && <span>Gestión Humana</span>}
                {!collapsed && (
                  <i
                    className={`bi ${
                      openSection === "humana" ? "bi-chevron-up" : "bi-chevron-down"
                    } float-end`}
                  />
                )}
              </button>

              {!collapsed && openSection === "humana" && (
                <ul className="sidebar-submenu">

                 {canAccess("ofertas") && (
                    <li>
                      <button
                        className={`sidebar-link ${
                          isActive("/session/offer/offers") ? "active" : ""
                        }`}
                        onClick={() => navigate("/session/offer/offers")}
                      >
                        <i className="bi bi-briefcase me-2"></i> Ofertas Laborales
                      </button>
                    </li>
                  )}
                  {canAccess("postulaciones") && (
                    <li>
                      <button
                        className={`sidebar-link ${
                          isActive("/session/postulation") ? "active" : ""
                        }`}
                        onClick={() => navigate("/session/postulation/postulations")}
                      >
                        <i className="bi bi-person-video2 me-2"></i> Postulaciones
                      </button>
                    </li>
                  )}

                  {canAccess("hojasdevida") && (
                    <li>
                      <button
                        className={`sidebar-link ${
                          isActive("/session/curriculum") ? "active" : ""
                        }`}
                        onClick={() => navigate(hojaVidaPath)}
                      >
                        <i className="bi bi-file-earmark-person me-3"></i>
                        {isHojaPropia ? "Mi Hoja de Vida" : "Hojas de Vida"}
                      </button>
                    </li>
                  )}
                  {canAccess("entrevistas") && (
                    <li>
                      <button
                        className={`sidebar-link ${
                          isActive("/session/interview/interview") ? "active" : ""
                        }`}
                        onClick={() => navigate("/session/interview/interview")}
                      >
                        <i className="bi bi-building-check me-2"></i> Entrevistas
                      </button>
                    </li>
                  )}
                  
                  {canAccess("examenocupacional") && (
                    <li>
                      <button
                        className={`sidebar-link ${
                          isActive("/session/occupational_exam") ? "active" : ""
                        }`}
                        onClick={() => navigate("/session/occupational_exam/occupationalExam")}
                      >
                        <i className="bi bi-hospital me-2"></i> Examen ocupacional
                      </button>
                    </li>
                  )}
                  {canAccess("contratacion") && canViewAllGH() && (
                    <li>
                      <button
                        className={`sidebar-link ${
                          isActive("/session/contract_gh/contract") ? "active" : ""
                        }`}
                        onClick={() => navigate("/session/contract_gh/contract")}
                      >
                       <i className="bi bi-file-earmark-text me-2"></i> Contratación
                      </button>
                    </li>
                  )}
                  {canAccess("reportes") && canViewAllGH() && (
                    <li>
                      <button
                        className={`sidebar-link ${
                          isActive("/session/report/report") ? "active" : ""
                        }`}
                        onClick={() => navigate("/session/report/report")}
                      >
                       <i className="bi bi-file-earmark-text me-2"></i> Reporte
                      </button>
                    </li>
                  )}
      
                </ul>
              )}
            </div>
          )}

          {/* PROYECTOS */}
          {canAccessProyectos && (
            <div className="sidebar-section">
              <button
                className="sidebar-section-btn"
                onClick={(e) =>
                  collapsed ? handleCollapsedClick(e, "proyecto") : toggleSection("proyecto")
                }
              >
                <i className="bi bi-bookmark-check-fill me-2"></i>
                {!collapsed && <span>Proyectos</span>}
                {!collapsed && (
                  <i
                    className={`bi ${
                      openSection === "proyecto" ? "bi-chevron-up" : "bi-chevron-down"
                    } float-end`}
                  />
                )}
              </button>

              {!collapsed && openSection === "proyecto" && (
                <ul className="sidebar-submenu">
                  {canAccess("entidades") && (
                    <li>
                      <button
                        className={`sidebar-link ${
                          isActive("/session/mod_proyectos/entity/entity") ? "active" : ""
                        }`}
                        onClick={() => navigate("/session/mod_proyectos/entity/entity")}
                      >
                        <i className="bi bi-file-earmark-text me-2"></i> Entidades
                      </button>
                    </li>
                  )}
                  {canAccess("propuestas") && (
                    <li>
                      <button
                        className={`sidebar-link ${
                          isActive("/session/mod_proyectos/proposal/proposal") ? "active" : ""
                        }`}
                        onClick={() => navigate("/session/mod_proyectos/proposal/proposal")}
                      >
                        <i className="bi bi-receipt me-2"></i> Propuestas
                      </button>
                    </li>
                  )}
                  {canAccess("contrato") && (
                    <li>
                      <button
                        className={`sidebar-link ${
                          isActive("/session/mod_proyectos/contrato_proyectos/contrato") ? "active" : ""
                        }`}
                        onClick={() => navigate("/session/mod_proyectos/contrato_proyectos/contrato")}
                      >
                        <i className="bi bi-clipboard-check-fill me-2"></i> Contrato
                      </button>
                    </li>
                  )}
                  {canAccess("asignacion_contrato") && (
                    <li>
                      <button
                        className={`sidebar-link ${
                          isActive("/session/mod_proyectos/area_assignment/assignment") ? "active" : ""
                        }`}
                        onClick={() => navigate("/session/mod_proyectos/area_assignment/assignment")}
                      >
                        <i className="bi bi-file-earmark-break-fill me-2"></i> Asignación contrato
                      </button>
                    </li>
                  )}
                </ul>
              )}
            </div>
          )}
          {/* PLAN ACCIÓN */}
          {canAccessPlanAccion && (
            <div className="sidebar-section">
              <button
                className="sidebar-section-btn"
                onClick={(e) =>
                  collapsed ? handleCollapsedClick(e, "plan_accion") : toggleSection("plan_accion")
                }
              >
                <i className="bi bi-send-check-fill me-2"></i>
                {!collapsed && <span>Plan de acción</span>}
                {!collapsed && (
                  <i
                    className={`bi ${
                      openSection === "plan_accion" ? "bi-chevron-up" : "bi-chevron-down"
                    } float-end`}
                  />
                )}
              </button>

              {!collapsed && openSection === "plan_accion" && (
                <ul className="sidebar-submenu">
                  {canAccess("programas") && (
                    <li>
                      <button
                        className={`sidebar-link ${
                          isActive("/session/plan_accion/programas") ? "active" : ""
                        }`}
                        onClick={() => navigate("/session/plan_accion/programas")}
                      >
                        <i className="bi bi-journal-plus me-2"></i> Programas
                      </button>
                    </li>
                  )}
                    {canAccess("program_files") && (
                    <li>
                      <button
                        className={`sidebar-link ${
                          isActive("/session/plan_accion/program_files") ? "active" : ""
                        }`}
                        onClick={() => navigate("/session/plan_accion/program_files")}
                      >
                        <i className="bi bi-file-earmark-break-fill me-2"></i> Documentos del programa
                      </button>
                    </li>
                  )}
                  {canAccess("plan") && (
                    <li>
                      <button
                        className={`sidebar-link ${
                          isActive("/session/plan_accion/plan_accion") ? "active" : ""
                        }`}
                        onClick={() => navigate("/session/plan_accion/plan_accion")}
                      >
                        <i className="bi bi-calculator r me-2"></i> Hitos de pago
                      </button>
                    </li>
                  )}

                </ul>
              )}
            </div>
          )}
          {/* AREA ADMNISTRATIVA*/}
          {canAccessAreaAdministrativa && (
            <div className="sidebar-section">
              <button
                className="sidebar-section-btn"
                onClick={(e) =>
                  collapsed ? handleCollapsedClick(e, "area_administrativa") : toggleSection("area_administrativa")
                }
              >
                <i className="bi bi-percent me-2"></i>
                {!collapsed && <span>Administrativa y Financiera</span>}
                {!collapsed && (
                  <i
                    className={`bi ${
                      openSection === "area_administrativa" ? "bi-chevron-up" : "bi-chevron-down"
                    } float-end`}
                  />
                )}
              </button>

              {!collapsed && openSection === "area_administrativa" && (
                <ul className="sidebar-submenu">
                  {canAccess("informacion_general") && (
                    <li>
                      <button
                        className={`sidebar-link ${
                          isActive("/session/mod_administrativa/informacion_general") ? "active" : ""
                        }`}
                        onClick={() => navigate("/session/mod_administrativa/informacion_general/informacion_general")}
                      >
                        <i className="bi bi-journal me-2"></i> Información general
                      </button>
                    </li>
                  )}

                </ul>
              )}
            </div>
          )}
          {/* CONFIGURACIÓN */}
          {canAccessConfiguracion && (
            <div className="sidebar-section">
              <button
                className="sidebar-section-btn"
                onClick={(e) =>
                  collapsed ? handleCollapsedClick(e, "configuracion") : toggleSection("configuracion")
                }
              >
                <i className="bi bi-gear-fill me-2"></i>
                {!collapsed && <span>Configuración</span>}
                {!collapsed && (
                  <i
                    className={`bi ${
                      openSection === "configuracion" ? "bi-chevron-up" : "bi-chevron-down"
                    } float-end`}
                  />
                )}
              </button>

              {!collapsed && openSection === "configuracion" && (
                <ul className="sidebar-submenu">
                  
                  {canAccess("usuarios") && (
                    <li>
                      <button
                        className={`sidebar-link ${
                          isActive("/session/user/user") ? "active" : ""
                        }`}
                        onClick={() => navigate("/session/user/user")}
                      >
                        <i className="bi bi-person-fill-gear me-2"></i> Módulo Usuarios
                      </button>
                    </li>
                  )}
                  {canAccess("centrocostos") && (
                    <li>
                      <button
                        className={`sidebar-link ${
                          isActive("/session/cost_center/cost_center") ? "active" : ""
                        }`}
                        onClick={() => navigate("/session/cost_center/cost_center")}
                      >
                        <i className="bi bi-coin me-2"></i> Centro de costos
                      </button>
                    </li>
                  )}

                </ul>
              )}
            </div>
          )}
        

        </div>

        {/* Cerrar sesión */}
        <div className="sidebar-user">
          <button className="logout-btn" onClick={logout}>
            <i className="bi bi-box-arrow-left me-1"></i>
            {!collapsed && "Cerrar sesión"}
          </button>
        </div>
      </div>

      {/* SUBMENÚS FLOTANTES */}
      {collapsed && hoverSubmenu === "humana" && canAccessGestionHumana && (
        <div className="floating-submenu" style={{ top: submenuPosition }}>
          <ul>
            {canAccess("ofertas") && (
              <li onClick={() => navigate("/session/offer/offers")}>
                <i className="bi bi-briefcase me-2"></i> Ofertas Laborales
              </li>
            )}
            {canAccess("postulaciones") && (
              <li onClick={() => navigate("/session/postulation/postulations")}>
                <i className="bi bi-person-video2 me-2"></i> Postulaciones
              </li>
            )}

            {canAccess("hojasdevida") && (
              <li onClick={() => navigate(hojaVidaPath)}>
                <i className="bi bi-file-earmark-person me-2"></i>
                {isHojaPropia ? " Mi Hoja de Vida" : " Hojas de Vida"}
              </li>
            )}
            {canAccess("entrevistas") && (
              <li onClick={() => navigate("/session/interview/interview")}>
                <i className="bi bi-building-check me-2"></i> Entrevista
              </li>
            )}
            {canAccess("examenocupacional") && (
              <li onClick={() => navigate("/session/occupational_exam/occupationalExam")}>
                <i className="bi bi-hospital me-2"></i> Examen ocupacional
              </li>
            )}

            {canAccess("contratacion") && canViewAllGH() && (
              <li onClick={() => navigate("/session/contract_gh/contract")}>
                <i className="bi bi-file-earmark-text me-2"></i> Contratación
              </li>
            )}
            {canAccess("reportes") && canViewAllGH() && (
              <li onClick={() => navigate("/session/report/report")}>
                <i className="bi bi-file-earmark-text me-2"></i> Reporte
              </li>
            )}
        
          </ul>
        </div>
      )}

      {collapsed && hoverSubmenu === "proyecto" && canAccessProyectos && (
        <div className="floating-submenu" style={{ top: submenuPosition }}>
          <ul>
             {canAccess("entidades") && (
              <li onClick={() => navigate("/session/mod_proyectos/entity/entity")}>
                <i className="bi bi-file-earmark-text me-2"></i> Entidades
              </li>
             )}
             {canAccess("propuestas") && (
              <li onClick={() => navigate("/session/mod_proyectos/proposal/proposal")}>
                <i className="bi bi-receipt me-2"></i> Propuestas
              </li>
             )}
             {canAccess("contrato") && (
              <li onClick={() => navigate("/session/mod_proyectos/contrato_proyectos/contrato")}>
                <i className="bi bi-clipboard-check-fill me-2"></i> Contrato
              </li>
             )}
             {canAccess("asignacion_contrato") && (
              <li onClick={() => navigate("/session/mod_proyectos/area_assignment/assignment")}>
                <i className="bi bi-file-earmark-break-fill me-2"></i> Asignación contrato
              </li>
             )}
          </ul>
        </div>
      )}
      {collapsed && hoverSubmenu === "plan_accion" && canAccessPlanAccion && (
        <div className="floating-submenu" style={{ top: submenuPosition }}>
          <ul>
            {canAccess("programas") && (
              <li onClick={() => navigate("/session/plan_accion/programas")}>
                <i className="bi bi-journal-plus me-2"></i> Programas
              </li>
            )}
            {canAccess("program_files") && (
              <li onClick={() => navigate("/session/plan_accion/program_files")}>
                <i className="bi bi-file-earmark-break-fill me-2"></i> Documentos del programa
              </li>
            )}
            {canAccess("plan") && (
              <li onClick={() => navigate("/session/plan_accion/plan_accion")}>
                <i className="bi bi-calculator me-2"></i> Hitos de pago
              </li>
            )}
          </ul>
        </div>
      )}
      {collapsed && hoverSubmenu === "area_administrativa" && canAccessAreaAdministrativa && (
        <div className="floating-submenu" style={{ top: submenuPosition }}>
          <ul>
            {canAccess("informacion_general") && (
              <li onClick={() => navigate("/session/mod_administrativa/informacion_general/informacion_general")}>
                <i className="bi bi-journal me-2"></i> Información general
              </li>
            )}
          </ul>
        </div>
      )}

      {collapsed && hoverSubmenu === "configuracion" && canAccessConfiguracion && (
        <div className="floating-submenu" style={{ top: submenuPosition }}>
          <ul>
            {canAccess("usuarios") && (
              <li onClick={() => navigate("/session/user/user")}>
                <i className="bi bi-person-fill-gear me-2"></i> Módulo Usuarios
              </li>
            )}
            {canAccess("centrocostos") && (
              <li onClick={() => navigate("/session/cost_center/cost_center")}>
                <i className="bi bi-coin me-2"></i> Centro de costos
              </li>
            )}
          </ul>
        </div>
      )}


    </>
  );
};

export default Sidebar;